export const FETCH_USER = 'fetch_user';
export const FETCH_USERS = 'fetch_users';
export const FETCH_ALBUM = 'fetch_album';
export const FETCH_RECIPIENT = 'fetch_recipient';
export const FETCH_INVITES = 'fetch_invites';
export const FETCH_RECIPIENT_USER = 'fetch_recipient_user';
export const PHOTO_SELECTED = 'photo_selected'
export const INIT = 'init'